module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('animated-pulse', [(_vm.show) ? _c('div', {
    class: _vm.classes
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.$emit('update:show', false)
      }
    }
  }), _vm._v(" "), _vm._t("default", [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.content)
    }
  })])], 2) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-12220bd6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/alert/alert.vue
// module id = 509
// module chunks = 84